import { Badge, IconButton, Box } from "@chakra-ui/react";
import { socialMenu } from "../../helper/HeaderMenu";
import { Dispatch } from "react";

interface Props {
  visible: boolean;
  setVisible: Dispatch<React.SetStateAction<boolean>>;
  count: number;
}

const CartIcon = ({ visible, setVisible, count }: Props) => {
  return (
    <Box position="relative" display="inline-block">
      <IconButton
        as="a"
        href={socialMenu[socialMenu.length - 1].href}
        aria-label={socialMenu[socialMenu.length - 1].ariaLabel}
        icon={socialMenu[socialMenu.length - 1].icon}
        size={socialMenu[socialMenu.length - 1].size}
        variant="ghost"
        fontSize={socialMenu[socialMenu.length - 1].fontSize}
        onClick={() => setVisible(!visible)}
      />
        <Badge
          colorScheme="red"
          borderRadius="full"
          px="2"
          position="absolute"
          top="0.5"
          right="0.5"
          fontSize="0.7em"
        >
          {count}
        </Badge>
    </Box>
  );
};

export default CartIcon;
